import React, { useEffect, useState } from 'react';
import { CSSProperties } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useTranslations } from '../../contexts/translationContext';
import { StringWithFormat } from "../../types/Result";

interface ActionMenuItemProps {
    title: string | StringWithFormat
    icon?: string
    iconVariant?: 'success' | 'danger'
    width?: number
    appFunction?: ApplicationFunctions
    attachmentTypeId?: number
    itemTypeId?: number
    projectTypeId?: number
    priceTypeId?: number
    workflowDefinitionId?: number
    disabled?: boolean
    visible?: boolean
    onClick?: () => void
}

const ActionMenuItem: React.FC<ActionMenuItemProps> = ({ title, icon, iconVariant, width, appFunction, attachmentTypeId, itemTypeId, projectTypeId, priceTypeId, workflowDefinitionId, disabled, visible, onClick }) => {
    const [titleText, setTitleText] = useState<string>('')
    const { translate } = useTranslations();
    const { isAuthorizedFor, isAuthorizedForAttachmentType, isAuthorizedForItemType, isAuthorizedForProjectType, isAuthorizedForPriceType, isAuthorizedForWorkflowDefinition } = useAuth();

    useEffect(() => {
        if (title) {
            if (typeof title !== 'string')
                translate('ActionMenuItem.Title: ' + title.format, undefined, title).then(translated => setTitleText(translated));
            else
                translate('ActionMenuItem.Title: ' + title, undefined, title).then(translated => setTitleText(translated));
        }
    }, [title]);

    if (visible == false)
        return null;

    if (appFunction) {
        let isAuthorized = false;
        if (attachmentTypeId !== undefined) {
            if (attachmentTypeId === 0)
                isAuthorized = isAuthorizedForAttachmentType(appFunction);
            else
                isAuthorized = isAuthorizedForAttachmentType(appFunction, attachmentTypeId);
        }

        else if (itemTypeId !== undefined) {
            if (itemTypeId === 0)
                isAuthorized = isAuthorizedForItemType(appFunction);
            else
                isAuthorized = isAuthorizedForItemType(appFunction, itemTypeId);
        }

        else if (projectTypeId !== undefined) {
            if (projectTypeId === 0)
                isAuthorized = isAuthorizedForProjectType(appFunction);
            else
                isAuthorized = isAuthorizedForProjectType(appFunction, projectTypeId);
        }

        else if (priceTypeId !== undefined) {
            if (priceTypeId === 0)
                isAuthorized = isAuthorizedForPriceType(appFunction);
            else
                isAuthorized = isAuthorizedForPriceType(appFunction, priceTypeId);
        }

        else if (workflowDefinitionId !== undefined) {
            if (workflowDefinitionId === 0)
                isAuthorized = isAuthorizedForWorkflowDefinition(appFunction);
            else
                isAuthorized = isAuthorizedForWorkflowDefinition(appFunction, workflowDefinitionId);

        }
        else
            isAuthorized = isAuthorizedFor(appFunction);
        

        if (!isAuthorized)
            return <></>;
    }
    let style: CSSProperties = {}
    if (width)
        style.minWidth = width;

    if (icon && iconVariant)
        return (
            <Dropdown.Item onClick={onClick} disabled={disabled} style={style}>
                <span className={'text-' + iconVariant}><i className={icon} /></span>
                {titleText}
            </Dropdown.Item>
        )

    return (
        <Dropdown.Item onClick={onClick} disabled={disabled} style={style}>
            {icon && <i className={icon} />}
            {titleText}
        </Dropdown.Item>
    )

}
export default ActionMenuItem